import React from 'react';
import { StanCard, StanTimezoneSelector } from '@/components';
import { useGlobalStore } from '@/stores/globalStore';
import { getLocalTimezone } from '@/lib';

export const AdminTab: React.FC = () => {
    const { sessionTimezone, setSessionTimezone } = useGlobalStore();

    const handleTimezoneChange = (timezone: string) => {
        setSessionTimezone(timezone);
    };

    return (
        <StanCard>
            <div className='w-full max-w-lg'>
                <h4 className='mb-6'>Admin</h4>

                <StanTimezoneSelector
                    selectedTimezone={sessionTimezone || getLocalTimezone()}
                    onTimezoneChange={handleTimezoneChange}
                    label={{ value: 'Change Dashboard Timezone', position: 'top' }}
                />
            </div>
        </StanCard>
    );
};

export default AdminTab;
